import { API2_HOST } from '../../helpers/urlHelper';
import { baseSearch, basePost, basePatch,baseGetWithoutParam } from 'services/base-services/baseService';

const baseURL = `${API2_HOST}/prospect-customers`;

const getCustomerTypes = async () => {
  return await baseGetWithoutParam(`${baseURL}/customer-type`);
}

const search = async request => {
  return await baseSearch(baseURL, request);
};

const post = async (request) => {
  return await basePost(baseURL, request);
};

const patch = async (id, request) => {
  return await basePatch(baseURL, request, id);
};

export { search, post, patch, getCustomerTypes };
